export default __webpack_public_path__ + "static/media/close.e4773424.svg";